import { Flex } from 'antd';
import { fontSize, lineHeight, spacing, textColor } from '../../theming';
import { cardStyle, colorDotStyle, labelStyle } from './vinExtractionStyles';

const bigNumberStyle = { fontSize: fontSize.H4, lineHeight: lineHeight.H4, fontWeight: 600, color: textColor.primary };

const StatCard = ({ id, color, label, hint, value, children }) => (
    <Flex vertical gap={spacing[0.5]} style={cardStyle} data-testid={`vin-stat-${id}`} role="group" aria-label={label}>
        <Flex align="center" gap={spacing[1]}>
            <span style={colorDotStyle(color)} aria-hidden="true" />
            <span style={labelStyle}>{label}</span>
        </Flex>
        <span style={bigNumberStyle}>{value}</span>
        {hint && <span style={labelStyle}>{hint}</span>}
        {children}
    </Flex>
);

export default StatCard;
